import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

import _0e4ebd82 from '../pages/about.vue'
import _58e2b95f from '../pages/account.vue'
import _851f06bc from '../pages/account/index.vue'
import _64a4435a from '../pages/account/comparisons.vue'
import _31bdb164 from '../pages/account/dashboard.vue'
import _5c9d4ed2 from '../pages/account/favorite-franchises.vue'
import _04bc411e from '../pages/account/franchise-university.vue'
import _53ba9f1c from '../pages/account/my-matches.vue'
import _1cbbebf9 from '../pages/account/profile.vue'
import _504c1b09 from '../pages/account-franchisor.vue'
import _1f7076cc from '../pages/account-franchisor/index.vue'
import _7b956f3b from '../pages/account-franchisor/budget.vue'
import _9d4694e8 from '../pages/account-franchisor/contacts/index.vue'
import _4180868e from '../pages/account-franchisor/dashboard.vue'
import _82219918 from '../pages/account-franchisor/onboarding-packet.vue'
import _3951fb38 from '../pages/account-franchisor/submissions/index.vue'
import _6ce467ea from '../pages/account-franchisor/tasks/index.vue'
import _bf83b2d2 from '../pages/account-franchisor/contacts/_contact.vue'
import _28fb3e46 from '../pages/account-franchisor/_franchiseId/steps/_step/index.vue'
import _070e1a17 from '../pages/account-franchisor/_franchiseId/steps/_step/chat/index.vue'
import _055778cf from '../pages/account-franchisor/_franchiseId/steps/_step/chat/_slug.vue'
import _c68fea3a from '../pages/blog/index.vue'
import _4c4135d4 from '../pages/chat-page.vue'
import _3addceae from '../pages/company-pages/index.vue'
import _28008fd8 from '../pages/contact-pre-register.vue'
import _704f0d4e from '../pages/disclaimer.vue'
import _dce02972 from '../pages/DM.vue'
import _6ea92d24 from '../pages/editor/index.vue'
import _26659bb2 from '../pages/franchise-directory/index.vue'
import _3e47ae3f from '../pages/franchise-glossary-definitions.vue'
import _64d55d08 from '../pages/franchise-university.vue'
import _37d9a91a from '../pages/franchisee-register.vue'
import _2e77f3c3 from '../pages/franchisee-steps/index.vue'
import _4e9ff9ae from '../pages/franchising-faqs.vue'
import _79d5f4e4 from '../pages/industry-reports.vue'
import _7316f614 from '../pages/membership.vue'
import _42fbb41f from '../pages/new-landing/index.vue'
import _24f4f362 from '../pages/own-franchise-steps.vue'
import _32621c58 from '../pages/pcmania/index.vue'
import _3a5785d5 from '../pages/privacy-policy.vue'
import _17cbd4c8 from '../pages/privacy-statement.vue'
import _0eddaaad from '../pages/radio.vue'
import _28d67c6e from '../pages/see-franchises.vue'
import _7ae38b8e from '../pages/terms.vue'
import _69d22ac0 from '../pages/test-component.vue'
import _e77ce88c from '../pages/test-editor.vue'
import _a517eea2 from '../pages/top-franchises/index.vue'
import _256bb744 from '../pages/auth/auto-login.vue'
import _0c4ee7fa from '../pages/auth/logout.vue'
import _4c4dd8cf from '../pages/franchise-directory/industries/index.vue'
import _0614f977 from '../pages/franchisee-steps/chat.vue'
import _0a3af2fd from '../pages/new/editor/index.vue'
import _9664896a from '../pages/blog/category/_category.vue'
import _c75485e2 from '../pages/blog/post/_post.vue'
import _08c62386 from '../pages/franchise-directory/industries/_industry/index.vue'
import _008f4560 from '../pages/new/landing/_landing/index.vue'
import _019fb334 from '../pages/franchise-directory/industries/_industry/_company/index.vue'
import _0c336616 from '../pages/franchise-directory/industries/_industry/_slug.vue'
import _695089fc from '../pages/new/landing/_landing/_page.vue'
import _050cf5c4 from '../pages/franchise-directory/industries/_industry/_company/_slug.vue'
import _7372150c from '../pages/company-pages/_company/index.vue'
import _a8860e8a from '../pages/new-landing/_page.vue'
import _38f3338c from '../pages/top-franchises/_category.vue'
import _76df579c from '../pages/company-pages/_company/_slug.vue'
import _18907c04 from '../pages/index.vue'
import _4e3c52dd from '../pages/index/auth/login.vue'
import _2d571dc3 from '../pages/index/auth/reset.vue'
import _49d85a0b from '../pages/index/email/confirm-change.vue'
import _669f550b from '../pages/index/auth/verify/_userId.vue'
import _5b7a6d99 from '../pages/_landing/index.vue'
import _77889b96 from '../pages/_landing/_page.vue'

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _0e4ebd82,
    name: "about___en"
  }, {
    path: "/account",
    component: _58e2b95f,
    children: [{
      path: "",
      component: _851f06bc,
      name: "account___en"
    }, {
      path: "comparisons",
      component: _64a4435a,
      name: "account-comparisons___en"
    }, {
      path: "dashboard",
      component: _31bdb164,
      name: "account-dashboard___en"
    }, {
      path: "favorite-franchises",
      component: _5c9d4ed2,
      name: "account-favorite-franchises___en"
    }, {
      path: "franchise-university",
      component: _04bc411e,
      name: "account-franchise-university___en"
    }, {
      path: "my-matches",
      component: _53ba9f1c,
      name: "account-my-matches___en"
    }, {
      path: "profile",
      component: _1cbbebf9,
      name: "account-profile___en"
    }]
  }, {
    path: "/account-franchisor",
    component: _504c1b09,
    children: [{
      path: "",
      component: _1f7076cc,
      name: "account-franchisor___en"
    }, {
      path: "budget",
      component: _7b956f3b,
      name: "account-franchisor-budget___en"
    }, {
      path: "contacts",
      component: _9d4694e8,
      name: "account-franchisor-contacts___en"
    }, {
      path: "dashboard",
      component: _4180868e,
      name: "account-franchisor-dashboard___en"
    }, {
      path: "onboarding-packet",
      component: _82219918,
      name: "account-franchisor-onboarding-packet___en"
    }, {
      path: "submissions",
      component: _3951fb38,
      name: "account-franchisor-submissions___en"
    }, {
      path: "tasks",
      component: _6ce467ea,
      name: "account-franchisor-tasks___en"
    }, {
      path: "contacts/:contact",
      component: _bf83b2d2,
      name: "account-franchisor-contacts-contact___en"
    }, {
      path: ":franchiseId/steps/:step",
      component: _28fb3e46,
      name: "account-franchisor-franchiseId-steps-step___en"
    }, {
      path: ":franchiseId/steps/:step?/chat",
      component: _070e1a17,
      name: "account-franchisor-franchiseId-steps-step-chat___en"
    }, {
      path: ":franchiseId/steps/:step?/chat/:slug",
      component: _055778cf,
      name: "account-franchisor-franchiseId-steps-step-chat-slug___en"
    }]
  }, {
    path: "/blog",
    component: _c68fea3a,
    name: "blog___en"
  }, {
    path: "/chat-page",
    component: _4c4135d4,
    name: "chat-page___en"
  }, {
    path: "/company-pages",
    component: _3addceae,
    name: "company-pages___en"
  }, {
    path: "/contact-pre-register",
    component: _28008fd8,
    name: "contact-pre-register___en"
  }, {
    path: "/disclaimer",
    component: _704f0d4e,
    name: "disclaimer___en"
  }, {
    path: "/DM",
    component: _dce02972,
    name: "DM___en"
  }, {
    path: "/editor",
    component: _6ea92d24,
    name: "editor___en"
  }, {
    path: "/franchise-directory",
    component: _26659bb2,
    name: "franchise-directory___en"
  }, {
    path: "/franchise-glossary-definitions",
    component: _3e47ae3f,
    name: "franchise-glossary-definitions___en"
  }, {
    path: "/franchise-university",
    component: _64d55d08,
    name: "franchise-university___en"
  }, {
    path: "/franchisee-register",
    component: _37d9a91a,
    name: "franchisee-register___en"
  }, {
    path: "/franchisee-steps",
    component: _2e77f3c3,
    name: "franchisee-steps___en"
  }, {
    path: "/franchising-faqs",
    component: _4e9ff9ae,
    name: "franchising-faqs___en"
  }, {
    path: "/industry-reports",
    component: _79d5f4e4,
    name: "industry-reports___en"
  }, {
    path: "/membership",
    component: _7316f614,
    name: "membership___en"
  }, {
    path: "/new-landing",
    component: _42fbb41f,
    name: "new-landing___en"
  }, {
    path: "/own-franchise-steps",
    component: _24f4f362,
    name: "own-franchise-steps___en"
  }, {
    path: "/pcmania",
    component: _32621c58,
    name: "pcmania___en"
  }, {
    path: "/privacy-policy",
    component: _3a5785d5,
    name: "privacy-policy___en"
  }, {
    path: "/privacy-statement",
    component: _17cbd4c8,
    name: "privacy-statement___en"
  }, {
    path: "/radio",
    component: _0eddaaad,
    name: "radio___en"
  }, {
    path: "/see-franchises",
    component: _28d67c6e,
    name: "see-franchises___en"
  }, {
    path: "/terms",
    component: _7ae38b8e,
    name: "terms___en"
  }, {
    path: "/test-component",
    component: _69d22ac0,
    name: "test-component___en"
  }, {
    path: "/test-editor",
    component: _e77ce88c,
    name: "test-editor___en"
  }, {
    path: "/top-franchises",
    component: _a517eea2,
    name: "top-franchises___en"
  }, {
    path: "/auth/auto-login",
    component: _256bb744,
    name: "auth-auto-login___en"
  }, {
    path: "/auth/logout",
    component: _0c4ee7fa,
    name: "auth-logout___en"
  }, {
    path: "/franchise-directory/industries",
    component: _4c4dd8cf,
    name: "franchise-directory-industries___en"
  }, {
    path: "/franchisee-steps/chat",
    component: _0614f977,
    name: "franchisee-steps-chat___en"
  }, {
    path: "/new/editor",
    component: _0a3af2fd,
    name: "new-editor___en"
  }, {
    path: "/blog/category/:category?",
    component: _9664896a,
    name: "blog-category-category___en"
  }, {
    path: "/blog/post/:post?",
    component: _c75485e2,
    name: "blog-post-post___en"
  }, {
    path: "/franchise-directory/industries/:industry",
    component: _08c62386,
    name: "franchise-directory-industries-industry___en"
  }, {
    path: "/new/landing/:landing",
    component: _008f4560,
    name: "new-landing-landing___en"
  }, {
    path: "/franchise-directory/industries/:industry/:company",
    component: _019fb334,
    name: "franchise-directory-industries-industry-company___en"
  }, {
    path: "/franchise-directory/industries/:industry/:slug",
    component: _0c336616,
    name: "franchise-directory-industries-industry-slug___en"
  }, {
    path: "/new/landing/:landing/:page",
    component: _695089fc,
    name: "new-landing-landing-page___en"
  }, {
    path: "/franchise-directory/industries/:industry/:company/:slug",
    component: _050cf5c4,
    name: "franchise-directory-industries-industry-company-slug___en"
  }, {
    path: "/company-pages/:company",
    component: _7372150c,
    name: "company-pages-company___en"
  }, {
    path: "/new-landing/:page?",
    component: _a8860e8a,
    name: "new-landing-page___en"
  }, {
    path: "/top-franchises/:category?",
    component: _38f3338c,
    name: "top-franchises-category___en"
  }, {
    path: "/company-pages/:company?/:slug",
    component: _76df579c,
    name: "company-pages-company-slug___en"
  }, {
    path: "/",
    component: _18907c04,
    name: "index___en",
    children: [{
      path: "auth/login",
      component: _4e3c52dd,
      name: "index-auth-login___en"
    }, {
      path: "auth/reset",
      component: _2d571dc3,
      name: "index-auth-reset___en"
    }, {
      path: "email/confirm-change",
      component: _49d85a0b,
      name: "index-email-confirm-change___en"
    }, {
      path: "auth/verify/:userId?",
      component: _669f550b,
      name: "index-auth-verify-userId___en"
    }]
  }, {
    path: "/:landing",
    component: _5b7a6d99,
    name: "landing___en"
  }, {
    path: "/:landing/:page",
    component: _77889b96,
    name: "landing-page___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
